import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { SUTransitReviewDecision, SUTransitApprovalDecision, Languages, ServiceStatus, FormMode } from 'src/app/shared/models/enums.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { AgentService } from 'src/app/front-user/services/e-booking/shared/services/agent.service';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs/operators';
import { EntranceRequestComponent } from 'src/app/front-user/services/small-units/entrance-request/entrance-request.component';
import { SmallUnitsAdminService } from '../shared/services/small-units.service.admin';
import { SmallUnitadminDTO } from '../shared/models/small-units-admin.model';
import { SmallUnitsServiceFE } from 'src/app/front-user/services/small-units/shared/services/small-units.service';
import { SmallUnitRequest } from 'src/app/front-user/services/small-units/shared/models/Small-Unit-Request.model';
import { CustomValidators } from 'src/app/front-user/shipyard-service/models/custom-validator';
//import { timeStamp } from 'console';

@Component({
  selector: 'app-ism-request-departure',
  templateUrl: './ism-request-departure.component.html',
  styleUrls: []
})


export class IsmRequestDepartureComponent implements OnInit {
  submitted = false;
  loading = false;
  baseRequestId: string = '';
  requestStatus: number;
  baseRequestDTO: BaseRequest//= new BaseRequest();
  decision = SUTransitReviewDecision;
  decisionKeys = Object.keys(this.decision);
  displayedLang: string;
  decisionValue: number;
  ismReviewTransitRequestForm: FormGroup;
  user: User = new User();
  agent: User = new User();
  smallunitRequestObj: SmallUnitRequest = new SmallUnitRequest();
  adminDecisionObject: SmallUnitadminDTO = new SmallUnitadminDTO();
  showRequest = false;
  agentId: string;
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  isLoaded: boolean = false;
  isErrorMessage: boolean = false;
  numberRegex: string = '^[0-9]+(\\.?[0-9]+)?$';
  @Input() public isShow: boolean = true;
  //@ViewChild('EntranceRequest') EntranceRequest: EntranceRequestComponent;
  responseObj: ResponseObject = new ResponseObject();
  lockTaskErrorMessage: boolean = false;
  TransitPostponedByIS: boolean = false;
  IsmailiaPostPoneNotes: string = '';
  TransitPostponedByISMarine: boolean;
  ISMMarinePostPoneNotes: string;

  constructor(private formBuilder: FormBuilder, private baseRequestService: BaseRequestService,
    private globalSrv: GlobalServices,
    private route: ActivatedRoute, private router: Router,
    private translate: TranslateService,
    private SmallUnitServ: SmallUnitsServiceFE,
    private authenticationService: AuthenticationService, private alertService: AlertService,
    private SmallUnitAdminServ: SmallUnitsAdminService, private agentSrv: AgentService) {
    // this.isShow = true;
    this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    //this.baseRequestId = this.route.snapshot.params.Id;
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getBaseRequest();
    } else {
      window.history.back();
    }

    this.user = this.globalSrv.user;

  }

  ngOnInit() {

    this.buildForm(null);
  }

  buildForm(decision) {
    this.ismReviewTransitRequestForm = this.formBuilder.group({

      TransitDate: ['', [Validators.required]],
      MoreInformation: ['', [Validators.required]],
    });
   // if (decision == SUTransitReviewDecision.MoreInformation) {
    //   this.reviewTransitRequestForm = this.formBuilder.group({
   //     Decision: ['', [Validators.required]],
    //     MoreInformation: ['', [Validators.required]],
    //   });
    // }
   // else if (decision == SUTransitReviewDecision.SEND_TO_ISDEPARTEMENT) {
    //   this.reviewTransitRequestForm = this.formBuilder.group({
    //     Decision: ['', [Validators.required]],
    //     TransitDate: ['', [Validators.required]],
    //   });
   // }
  }
  // changeDecision(value) {
  //   this.buildForm(value);
  //   this.reviewTransitRequestForm.patchValue({
  //     Decision: value
  //   });
  //   this.decisionValue = value;
  // }

  get f() {
    return this.ismReviewTransitRequestForm.controls;
  }

  getBaseRequest() {
    this.SmallUnitServ.get(this.baseRequestId).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.smallunitRequestObj = this.responseObj.Data;
          this.requestStatus = this.smallunitRequestObj.StatusId;
          this.agentId = this.smallunitRequestObj.RequestorId;
          this.isLoaded = true;
          // check if transit postponed

          if (this.smallunitRequestObj.StatusId == ServiceStatus.SmallUnit_ISMTransitPostponed_PendingFinalFees && this.smallunitRequestObj.ISMarineActionId == SUTransitApprovalDecision.Postpone) {
            this.TransitPostponedByIS = true;
            this.IsmailiaPostPoneNotes = this.smallunitRequestObj.ISMarineNotes;
          } else if(this.smallunitRequestObj.StatusId == ServiceStatus.SmallUnit_ISMTransitPostponed_PendingFinalFees &&  this.smallunitRequestObj.ISMarineConfirmActionId  == SUTransitApprovalDecision.Postpone) {
            this.TransitPostponedByISMarine = true;
            this.ISMMarinePostPoneNotes = this.smallunitRequestObj.ISMarineConfirmMoreInformation;
          }
          if (history.state.data && history.state.data.isCompleted) {

            // this.decisionValue = this.smallunitRequestObj.ISMSmallUnitTransitActionId;

            // if (this.smallunitRequestObj.ISMSmallUnitTransitActionId == SUTransitReviewDecision.MoreInformation) {
              this.buildForm(null);
            //   this.reviewTransitRequestForm.patchValue({
            //     Decision: SUTransitReviewDecision.MoreInformation,
            //     MoreInformation: this.smallunitRequestObj.ISMSmallUnitTransitMoreInformation
            //   });
            // }
            // else {
            //   this.buildForm(this.decisionValue);
            //   this.reviewTransitRequestForm.patchValue({
            //     Decision: SUTransitReviewDecision.SEND_TO_ISDEPARTEMENT,
            //     TransitDate: new Date(this.smallunitRequestObj.ISMSmallUnitTransitDate),
            //   });
            // }
              this.ismReviewTransitRequestForm.patchValue({
                // Decision: SUTransitReviewDecision.MoreInformation,
                TransitDate: new Date(this.smallunitRequestObj.ISMSmallUnitTransitDate),
                MoreInformation: this.smallunitRequestObj.ISMSmallUnitTransitMoreInformation
              });
            // }
            // else {
            //   this.buildForm(null);
            //   this.reviewTransitRequestForm.patchValue({
            //     // Decision: SUTransitReviewDecision.SEND_TO_ISDEPARTEMENT,
            //     TransitDate: new Date(this.smallunitRequestObj.ISMSmallUnitTransitDate),
            //     MoreInformation: this.smallunitRequestObj.ISMSmallUnitTransitMoreInformation
            //   });
            // }
            this.formMode = FormMode.Readonly;
            this.ismReviewTransitRequestForm.disable();
          }
          else if (this.requestStatus == ServiceStatus.SmallUnit_ISMUnitArrivalConfirmed_PendingFinalFees || this.requestStatus == ServiceStatus.SmallUnit_ISMTransitPostponed_PendingFinalFees) {
            this.formMode = FormMode.Add;
            this.ismReviewTransitRequestForm.enable();
          }
          else {
            this.formMode = FormMode.Readonly;
            this.ismReviewTransitRequestForm.disable();
            // if (this.smallunitRequestObj.ISMSmallUnitTransitActionId == SUTransitReviewDecision.MoreInformation) {
              this.buildForm(null);
              this.ismReviewTransitRequestForm.patchValue({
                // Decision: SUTransitReviewDecision.MoreInformation,
                TransitDate: new Date(this.smallunitRequestObj.ISMSmallUnitTransitDate),
                MoreInformation: this.smallunitRequestObj.ISMSmallUnitTransitMoreInformation
              });
            // }
            // else {
            //   this.decisionValue = this.smallunitRequestObj.ISMSmallUnitTransitActionId;
            //   this.buildForm(this.decisionValue);
            //   this.reviewTransitRequestForm.patchValue({
            //     Decision: SUTransitReviewDecision.SEND_TO_ISDEPARTEMENT,
            //     TransitDate: new Date(this.smallunitRequestObj.ISMSmallUnitTransitDate),
            //   });
            // }

          }
        }
      }
    )
  }


  onSubmit(b) {

    this.submitted = true;
    // stop here if form is invalid
    if (this.ismReviewTransitRequestForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;

     this.adminDecisionObject = this.ismReviewTransitRequestForm.value;
     this.adminDecisionObject.AdminEmail = this.user.UserName;
     this.adminDecisionObject.Id = this.baseRequestId;
    //this.adminDecisionObject.ISMSmallUnitTransitActionId = this.reviewTransitRequestForm.controls.Decision.value;
     // if (this.adminDecisionObject.ISMSmallUnitTransitActionId == SUTransitReviewDecision.MoreInformation) {
      // this.adminDecisionObject.ISMSmallUnitTransitMoreInformation = this.reviewTransitRequestForm.controls.MoreInformation.value;
     //}
    // else if (this.adminDecisionObject.ISMSmallUnitTransitActionId == SUTransitReviewDecision.SEND_TO_ISDEPARTEMENT)
     //{
     if (this.ismReviewTransitRequestForm.get("TransitDate").value)
     {
         var selectedTransitDate = this.ismReviewTransitRequestForm.get("TransitDate").value.toLocaleString('en-US');
        this.ismReviewTransitRequestForm.controls['TransitDate'].setValue(selectedTransitDate);
    }
      this.adminDecisionObject.ISMSmallUnitTransitDate = this.ismReviewTransitRequestForm.controls.TransitDate.value;
      this.adminDecisionObject.ISMSmallUnitTransitMoreInformation = this.ismReviewTransitRequestForm.controls.MoreInformation.value;
    //}




    this.SmallUnitAdminServ.ISMDepatureRequest(this.adminDecisionObject)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            //this.alertService.success('Decision Submitted Successfully', false);
            this.ismReviewTransitRequestForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            //this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.'+data.ErrorMessages[0]), false);

            this.loading = false;
          }

        });
  }
}
